import { buildCreateSlice, asyncThunkCreator } from '@reduxjs/toolkit';

import { initialState } from './initial';
import { reducers } from './reducers';

export const createAppSlice = buildCreateSlice({
  creators: { asyncThunk: asyncThunkCreator },
});

export const accessSlice = createAppSlice({
  name: 'access',
  initialState,
  reducers,
});

export const { getUsers, getMoreUsers, replaceAccess, revokeAccess, grantUserAccess, updateAccess } =
  accessSlice.actions;

export default accessSlice.reducer;
